module.exports = __webpack_public_path__ + "img/lmf-logo.a9be2f7d.png";